import { ColumnSort, TableDataWithImage } from '@spo/logic';
import { Table } from '@tanstack/react-table';
import './smTable.scss';
import { TableBody } from './tableBody';
import { TableHeader } from './tableHeader';

interface SMTableViewProps {
  table: Table<TableDataWithImage>;
  columnSort: ColumnSort;
  setColumnSort: (columnSort: ColumnSort) => void;
  globalChecked: boolean;
  handleGlobalSmSelection: (status: boolean) => void;
  onCellClick?: (smId: string, startDate: string, endDate: string) => void;
  selectedSmIds: string[];
  selectSmId: (smId: string) => void;
}

export const SMTableView = ({
  table,
  columnSort,
  setColumnSort,
  globalChecked,
  handleGlobalSmSelection,
  onCellClick,
  selectedSmIds,
  selectSmId,
}: SMTableViewProps) => {
  return (
    <table>
      <TableHeader
        data-testid="sm-table-header"
        headersGroup={table?.getHeaderGroups()}
        columnSort={columnSort}
        setColumnSort={setColumnSort}
        globalChecked={globalChecked}
        setSelectAll={handleGlobalSmSelection}
      />
      <TableBody
        data-testid="sm-table-body"
        table={table}
        onCellClick={onCellClick}
        selectedSmIds={selectedSmIds}
        selectSmId={selectSmId}
      />
    </table>
  );
};
